import { EXTENSION_SLOT_COMPONENT } from "@smallstack/common-components";
import { ExtensionSlotComponent } from "./components/extension-slot/extension-slot.component";

export const EXTENSION_SLOT_COMPONENT_PROVIDER = {
  provide: EXTENSION_SLOT_COMPONENT,
  useValue: ExtensionSlotComponent
};
